<template>
  <div ref="popupRef" :class="['tooltip', '']" :data-placement="placement">
    <div ref="triggerRef" class="tooltip__trigger" @mouseover="handleMouseover" @mouseout="handleMouseout">
      <slot />
    </div>
    <div ref="tooltipRef" class="tooltip__inner" :style="popupStyle" v-show="isShowContent">
      <div>
        <slot name="content">{{ content }}</slot>
      </div>
      <div class="tooltip__arrow" data-popper-arrow></div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import { createPopper } from '@popperjs/core';

const props = withDefaults(defineProps<{
  content: string
  theme: string
  with?: number
  placement: string,
  popupStyle?: string,
}>(), {
  content: '',
  theme: 'default',
  placement: 'top'
})


const triggerRef = ref<HTMLElement>();
const tooltipRef = ref<HTMLElement>();
const popupRef = ref<HTMLElement>();

const isShowContent = ref(false)

const handleMouseover = () => {
  // 计算坐标
  isShowContent.value = true;

  createPopper(triggerRef.value!, tooltipRef.value!, {
    placement: 'top',
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: [0, 10],
        },
      },
    ],
  })
}

const handleMouseout = () => {
  isShowContent.value = false;
}
</script>
<style lang="less">
.tooltip {
  position: relative;
  display: inline-flex;
  align-items: center;

  &__trigger {
    display: inline-flex;
  }

  &__inner {
    width: auto;
    border: 1px solid #c5c3c4;
    border-radius: 5px;
    background-color: #fff;
    line-height: 25px;
    color: #029be9;
    font-size: 12px;
    position: absolute;
    overflow-wrap: break-word;
    padding: 0 6px;
    white-space: nowrap;
    text-align: left;

    span {
      width: 0;
      height: 0;
      font-size: 0;
      overflow: hidden;
      position: absolute;

      &.bot {
        border-width: 5px;
        border-style: solid dashed dashed;
        border-color: #c5c3c4 transparent transparent;
        left: 10px;
        bottom: -10px;
      }

      &.top {
        border-width: 5px;
        border-style: solid dashed dashed;
        border-color: #fff transparent transparent;
        left: 10px;
        bottom: -9px;
      }
    }
  }

  &__arrow {
    position: absolute;
    width: 10px;
    z-index: -1;
    height: 10px;

    &::before {
      z-index: -1;
      width: 10px;
      height: 10px;
      content: '';
      position: absolute;
      background-color: #fff;
      border: 1px solid #c5c3c4;
      transform: rotate(45deg);
    }
  }

  &__inner[data-popper-placement^="top"] &__arrow {
    bottom: -5px;

    &::before {
      border-bottom-right-radius: 2px;
      border-top-color: transparent !important;
      border-left-color: transparent !important;
    }
  }
}
</style>